var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSameDay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 34C1 21.0786 1 14.618 4.13166 9.99445C5.42888 8.07926 7.07926 6.42888 8.99445 5.13166C13.618 2 20.0786 2 33 2C45.9214 2 52.382 2 57.0056 5.13166C58.9207 6.42888 60.5711 8.07926 61.8683 9.99445C65 14.618 65 21.0786 65 34C65 46.9214 65 53.382 61.8683 58.0056C60.5711 59.9207 58.9207 61.5711 57.0056 62.8683C52.382 66 45.9214 66 33 66C20.0786 66 13.618 66 8.99445 62.8683C7.07926 61.5711 5.42888 59.9207 4.13166 58.0056C1 53.382 1 46.9214 1 34Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iif)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4939 34.2472C55.4939 46.534 45.5336 56.4944 33.2469 56.4944C20.9603 56.4944 11 46.534 11 34.2472C11 21.9604 20.9603 12 33.2469 12C45.5336 12 55.4939 21.9604 55.4939 34.2472Z",
    fill: "url(#paint1_linear)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 7C13 6.44772 13.6716 6 14.5 6H51.5C52.3284 6 53 6.44772 53 7V7C53 7.55228 52.3284 8 51.5 8H14.5C13.6716 8 13 7.55228 13 7V7Z",
    fill: "#E4F7F7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter2_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 6.6C19 6.26863 19.4701 6 20.05 6H45.95C46.5299 6 47 6.26863 47 6.6V6.6C47 6.93137 46.5299 7.2 45.95 7.2H20.05C19.4701 7.2 19 6.93137 19 6.6V6.6Z",
    fill: "#E4F7F7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6919 53.875C61.2777 53.875 60.9419 53.5392 60.9419 53.125V14.625C60.9419 14.2108 61.2777 13.875 61.6919 13.875V13.875C62.1061 13.875 62.4419 14.2108 62.4419 14.625V53.125C62.4419 53.5392 62.1061 53.875 61.6919 53.875V53.875Z",
    fill: "#BDEBEA"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.56689 53.875C4.35979 53.875 4.19189 53.7071 4.19189 53.5L4.19189 14.25C4.19189 14.0429 4.35979 13.875 4.56689 13.875V13.875C4.774 13.875 4.94189 14.0429 4.94189 14.25L4.94189 53.5C4.94189 53.7071 4.774 53.875 4.56689 53.875V53.875Z",
    fill: "#D1F1F0"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4459 20.2031C5.21606 20.2031 5.03274 20.0444 5.04556 19.8522C5.12738 18.625 5.50597 14.4894 6.97626 12.4368C8.58739 10.1877 12.1893 8.35541 12.7084 8.09899C12.751 8.07794 12.7972 8.06829 12.8467 8.06829V8.06829C13.1041 8.06829 13.2323 8.3321 13.0475 8.48204C11.9713 9.35473 9.47449 11.4265 8.13525 12.9222C6.64728 14.584 6.00828 18.7349 5.85502 19.8967C5.83193 20.0717 5.65618 20.2031 5.4459 20.2031V20.2031Z",
    fill: "#E4F7F7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6665 20.707C60.867 20.707 61.027 20.5417 61.0158 20.3415C60.9444 19.0631 60.6141 14.7552 59.3312 12.6171C57.9255 10.2743 54.7828 8.36566 54.3298 8.09855C54.2927 8.07663 54.2523 8.06658 54.2092 8.06658V8.06658C53.9846 8.06658 53.8727 8.34138 54.034 8.49757C54.973 9.40662 57.1515 11.5647 58.32 13.1228C59.6183 14.8538 60.1758 19.1776 60.3095 20.3878C60.3297 20.5702 60.483 20.707 60.6665 20.707V20.707Z",
    fill: "#E4F7F7"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.165 13.5192C7.11104 13.4986 7.08412 13.4384 7.10587 13.3849C7.21356 13.12 7.53794 12.3607 7.96898 11.7069C8.43377 11.0019 9.11115 10.5708 9.27513 10.473C9.29833 10.4592 9.32643 10.4572 9.35166 10.4669V10.4669C9.41918 10.4926 9.43266 10.5831 9.37588 10.6278C9.1105 10.8367 8.50685 11.3331 8.16442 11.7816C7.79365 12.2672 7.41891 13.1649 7.30078 13.4599C7.2793 13.5135 7.21897 13.5398 7.165 13.5192V13.5192Z",
    fill: "#F7FDFD"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.8919 13.5192C58.9458 13.4986 58.9728 13.4384 58.951 13.3849C58.8433 13.12 58.5189 12.3607 58.0879 11.7069C57.6231 11.0019 56.9457 10.5708 56.7818 10.473C56.7586 10.4592 56.7305 10.4572 56.7052 10.4669V10.4669C56.6377 10.4926 56.6242 10.5831 56.681 10.6278C56.9464 10.8367 57.55 11.3331 57.8925 11.7816C58.2632 12.2672 58.638 13.1649 58.7561 13.4599C58.7776 13.5135 58.8379 13.5398 58.8919 13.5192V13.5192Z",
    fill: "#E4F7F7"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5559 26.3992C25.6906 26.3992 24.8641 26.7382 24.2572 27.3366C23.6508 27.9344 23.3133 28.7416 23.3133 29.5798V39.3387C23.3133 40.1769 23.6508 40.9842 24.2572 41.582C24.8641 42.1803 25.6906 42.5193 26.5559 42.5193H29.8553C30.4941 42.5193 31.0119 43.0372 31.0119 43.676C31.0119 44.3148 30.4941 44.8326 29.8553 44.8326H26.5559C25.0876 44.8326 23.6762 44.2577 22.6331 43.2293C21.5894 42.2003 21 40.8011 21 39.3387V29.5798C21 28.1174 21.5894 26.7183 22.6331 25.6893C23.6762 24.6608 25.0876 24.0859 26.5559 24.0859H38.6538C40.122 24.0859 41.5334 24.6608 42.5765 25.6893C43.6202 26.7183 44.2096 28.1174 44.2096 29.5798V32.8328C44.2096 33.4716 43.6918 33.9894 43.053 33.9894C42.4142 33.9894 41.8964 33.4716 41.8964 32.8328V29.5798C41.8964 28.7416 41.5588 27.9344 40.9524 27.3366C40.3456 26.7382 39.519 26.3992 38.6538 26.3992H26.5559Z",
    fill: "#F2F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7553 23C29.3941 23 29.9119 23.5178 29.9119 24.1566V26.3253C29.9119 26.9641 29.3941 27.4819 28.7553 27.4819C28.1165 27.4819 27.5986 26.9641 27.5986 26.3253V24.1566C27.5986 23.5178 28.1165 23 28.7553 23Z",
    fill: "#F2F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4545 23C37.0933 23 37.6111 23.5178 37.6111 24.1566V26.3253C37.6111 26.9641 37.0933 27.4819 36.4545 27.4819C35.8157 27.4819 35.2979 26.9641 35.2979 26.3253V24.1566C35.2979 23.5178 35.8157 23 36.4545 23Z",
    fill: "#F2F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 30.6625C21 30.0237 21.5178 29.5059 22.1566 29.5059H43.053C43.6918 29.5059 44.2096 30.0237 44.2096 30.6625C44.2096 31.3013 43.6918 31.8191 43.053 31.8191H22.1566C21.5178 31.8191 21 31.3013 21 30.6625Z",
    fill: "#F2F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1271 38.1376C41.5755 38.5924 41.5703 39.3248 41.1155 39.7732L39.4657 41.3997C39.0109 41.8482 38.2785 41.843 37.8301 41.3881C37.3816 40.9332 37.3868 40.2009 37.8417 39.7524L39.4914 38.126C39.9463 37.6775 40.6786 37.6827 41.1271 38.1376Z",
    fill: "#F2F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6535 36.157C36.2397 36.157 34.3111 38.0819 34.3111 40.422C34.3111 42.762 36.2397 44.6869 38.6535 44.6869C41.0672 44.6869 42.9959 42.762 42.9959 40.422C42.9959 38.0819 41.0672 36.157 38.6535 36.157ZM31.9978 40.422C31.9978 36.7735 34.9932 33.8438 38.6535 33.8438C42.3138 33.8438 45.3091 36.7735 45.3091 40.422C45.3091 44.0704 42.3138 47.0002 38.6535 47.0002C34.9932 47.0002 31.9978 44.0704 31.9978 40.422Z",
    fill: "#F2F5F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iif",
    x: 9.5,
    y: 11.1047,
    width: 46.9939,
    height: 46.2849,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.895261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79052
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.506209 0 0 0 0 0.537255 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.5,
    dy: -0.895261
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.435294 0 0 0 0 0.827451 0 0 0 0 0.819608 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect3_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 7,
    y: 0,
    width: 52,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    x: 15,
    y: 2,
    width: 36,
    height: 9.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 56.9419,
    y: 9.875,
    width: 9.5,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f",
    x: 0.191895,
    y: 9.875,
    width: 8.75,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f",
    x: 2.24492,
    y: 5.26836,
    width: 13.6899,
    height: 17.7348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f",
    x: 51.1578,
    y: 5.26641,
    width: 12.6586,
    height: 18.2405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f",
    x: 6.0686,
    y: 9.08984,
    width: 4.37025,
    height: 5.80306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f",
    x: 55.6179,
    y: 9.08984,
    width: 4.37025,
    height: 5.80306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d",
    x: 21,
    y: 23,
    width: 26.3091,
    height: 26.5002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.207843 0 0 0 0 0.658954 0 0 0 0 0.67451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 33,
    y1: 2,
    x2: 33.3596,
    y2: 67.2247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487222,
    stopColor: "#44CAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23A5A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 35.5,
    y1: 7.5,
    x2: 35.5,
    y2: 68.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.122917,
    stopColor: "#66D5D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AADB0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSameDay);
export default __webpack_public_path__ + "static/media/icon_same_day.89cbc05a2024d1d33af14dd13c79317b.svg";
export { ForwardRef as ReactComponent };